import React, { useEffect } from "react";
import { useIsomorphicData } from "@crystal/core";
import { featureFlagsContext } from "./context.js";
import { loadFeatureFlags } from "../lib/helper.js";
const FeatureFlagsProvider = ({
  context,
  flags,
  children,
  tag = "",
  ...props
}) => {
  const staticFlags = flags == null ? void 0 : flags.evaluateWithContext(context);
  const project = props.project || props.projectName || "";
  if (!flags && !project) {
    throw '"project" is required in <FeatureFlagsProvider />.';
  }
  const fetchInfo = project ? {
    project,
    context
  } : void 0;
  const {
    data: apiFlags,
    info: dataInfo,
    refetch
  } = useIsomorphicData(
    {
      id: `flags_${project}-${context.brand}-${context.locale}-${tag}`,
      info: fetchInfo
    },
    async (info) => {
      if (info) {
        return loadFeatureFlags(info.project, info.context);
      }
    }
  );
  useEffect(() => {
    if (!fetchInfo || !dataInfo) {
      return;
    }
    const isContextEqual = Object.entries(fetchInfo.context).every(
      ([key, val]) => dataInfo.context[key] === val
    );
    if (fetchInfo.project !== dataInfo.project && !isContextEqual) {
      refetch(fetchInfo);
    }
  }, [fetchInfo, dataInfo]);
  const contextData = {
    flags: {
      ...staticFlags,
      ...apiFlags
    }
  };
  return /* @__PURE__ */ React.createElement(featureFlagsContext.Provider, { value: contextData }, children);
};
export {
  FeatureFlagsProvider
};
//# sourceMappingURL=provider.js.map
